import React from "react";

export const Local_Data = React.createContext({})

export const ANIMATION__CONTEXT = React.createContext(false)